function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import { useElementPosition, useElementSize } from '@bydesign-ui/hooks';
import React, { useRef, useState } from 'react';
import { usePrefixCls } from '@byte-design/config';
import { Tooltip } from '../tooltip';
export function RateCharItem(props) {
  var _props$value = props.value,
      value = _props$value === void 0 ? 0 : _props$value,
      character = props.character,
      tooltip = props.tooltip,
      activeColor = props.activeColor,
      disabled = props.disabled,
      onClick = props.onClick,
      onHover = props.onHover,
      allowHalf = props.allowHalf,
      extra = _objectWithoutProperties(props, ["value", "character", "tooltip", "activeColor", "disabled", "onClick", "onHover", "allowHalf"]);

  var charRef = useRef(null);

  var _useState = useState(0),
      _useState2 = _slicedToArray(_useState, 2),
      width = _useState2[0],
      seWidth = _useState2[1];

  var _useState3 = useState(0),
      _useState4 = _slicedToArray(_useState3, 2),
      starX = _useState4[0],
      setStarX = _useState4[1];

  var wrapCls = usePrefixCls('rate-char', {
    disabled: disabled
  });
  var innerCls = usePrefixCls('rate-char-bg');

  var renderCharacter = function renderCharacter(node) {
    if (!disabled && tooltip) {
      return React.createElement(Tooltip, {
        trigger: "hover",
        placement: "top",
        content: tooltip
      }, node);
    }

    return node;
  };

  useElementSize(charRef, function () {
    return true;
  }, function (size) {
    seWidth(size.width);
  });

  var handleMouseMove = function handleMouseMove(e) {
    var pageX = e.pageX;

    if (!disabled) {
      if (allowHalf) {
        if (pageX - starX <= width / 2 && pageX - starX > 0) {
          onHover(false);
        } else if (pageX - starX > width / 2 && pageX - starX <= width) {
          onHover(true);
        } else {
          return;
        }
      } else {
        onHover(true);
      }
    }
  };

  useElementPosition(charRef, function () {
    return true;
  }, function (position) {
    setStarX(position.left);
  }, {});
  return React.createElement("div", {
    className: wrapCls,
    ref: charRef,
    onClick: onClick,
    onMouseMove: handleMouseMove
  }, renderCharacter(character), React.createElement("div", {
    className: innerCls,
    style: {
      width: "".concat(value * 100, "%"),
      overflow: 'hidden',
      color: activeColor
    }
  }, renderCharacter(character)));
}